import { render, staticRenderFns } from "./GoodsSliderImageSelector.vue?vue&type=template&id=1ecdbe3c&scoped=true&"
import script from "./GoodsSliderImageSelector.vue?vue&type=script&lang=js&"
export * from "./GoodsSliderImageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecdbe3c",
  null
  
)

export default component.exports